import React, { useState, useEffect, useId } from 'react';
import TextInfo, {
  TEXT_FONT_WEIGHT,
  TEXT_COLOR,
  TEXT_SIZE,
} from '@gc-npm/components.text';
import { useSelector } from 'react-redux';
import { useRouter } from "next/router";
import styles from './style';
import { generateQueryString } from "@/utils/normalizers/product";
import { createBrowserHistory } from "history";
import { getFullUrl } from '@/utils/htmlUtils';

const RadioFilter = () => {
  const router = useRouter();
  const { query } = router;
  const history = typeof window === 'undefined' ? '' : createBrowserHistory();
  const {
    selectedFilters,
    sort,
    sortingKeys,
    searcherQuery,
    id,
  } = useSelector((state) => state.devicesList);
  const [orderSelected, setOrderSelected] = useState(sort);
  const radioGroupName = useId();

  useEffect(() => {
    setOrderSelected(sort);
  }, [sort]);

  const handleOptionChange = (event) => {
    handleOnChangeOrder(event.target.value);
  };

  const handleOnChangeOrder = (value) => {
    setOrderSelected(value)
    const ModalOpen = history.location && history.location.hash === '#FiltersModal';
    const selectedFiltersNew = selectedFilters;
    selectedFiltersNew.sort = value;
    if (searcherQuery) selectedFiltersNew.query = searcherQuery;
    selectedFiltersNew.id = id;
    const url = `${getFullUrl(`/${id}?${generateQueryString(
      selectedFiltersNew
    )}`, query)}${ModalOpen ? '#FiltersModal' : ''}`;
    router.replace(url, undefined, { shallow: true });
  };

  return (
    <div className={`filterBox`} role="radiogroup" aria-label="Ordenar resultados">
      {sortingKeys.map((sortingKey) => (
        <label key={sortingKey.id} className="filterContainer">
          <TextInfo
            text={`${sortingKey.name}`}
            size={TEXT_SIZE.SUBTITLE2}
            color={TEXT_COLOR.GREY_700}
            fontType={TEXT_FONT_WEIGHT.REGULAR}
          />
          <input
            type="radio"
            name={radioGroupName}
            value={sortingKey.id}
            checked={orderSelected === sortingKey.id}
            onChange={handleOptionChange}
          />
        </label>
      ))}
      <style jsx>{styles}</style>
    </div>
  );
};

export default RadioFilter;
